import React from 'react';
import { Outlet } from 'react-router-dom';

import Header from './Header';
import SidebarLayout from './SidebarLayout';
import PageContent from './PageContent';
import './styles.scss';
import { useContext } from 'react';
import { LayoutConteact } from '../context/appLayout';

const MainLayout = () => {
	const { isSidbarCollapsed } = useContext(LayoutConteact);
	return (
		<div className={`min-vh-100 wrapper p-0 m-0 ${isSidbarCollapsed ? '-colap' : ''}`}>
			<SidebarLayout />
			<Header />


			<div className={`cayesh-content-wrapper ${isSidbarCollapsed ? 'nav--collapse' : ''}`}>

				<div className='cayesh-main-wrapper'>
				<PageContent>
					{/* <main className='main'> */}
					{/* <button
            className="btn btn-primary"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasExample"
            aria-controls="offcanvasExample">
            Button with data-bs-target
          </button> */}
					<Outlet />
					{/* </main> */}
				</PageContent>
				</div>
				
			</div>

		</div>
	);
};

export default MainLayout;
